<script setup lang="ts">
import { PlatformImage } from '@webapp2/shared/components/platform-image'
import { buildPlatforms } from '../model'
import { Select } from './primevue/select'

const options = buildPlatforms.map(x => ({ label: x.charAt(0).toUpperCase() + x.slice(1), value: x }))
</script>

<template>
  <Select :show-filter="false" :options="options">
    <template #option="slotProps">
      <div class="flex gap-2">
        <PlatformImage :platform="slotProps.option.value" class="w-4" />
        <span>{{ slotProps.option.label }}</span>
      </div>
    </template>
  </Select>
</template>
